/* Remember browsing positions in this tab; leave browser history and theme filters intact. */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;
  var key = 'eclectique:scroll:v1';
  var positions = {};
  var restoring = false;
  var timer;
  var deadline;
  var lastURL = location.href;
  try { positions = JSON.parse(sessionStorage.getItem(key) || '{}') || {}; } catch (error) {}
  if ('scrollRestoration' in history) history.scrollRestoration = 'auto';

  function save() {
    if (restoring) return;
    positions[location.href] = { x: window.scrollX, y: window.scrollY, time: Date.now() };
    var urls = Object.keys(positions).sort(function (a, b) { return positions[b].time - positions[a].time; });
    urls.slice(80).forEach(function (url) { delete positions[url]; });
    try { sessionStorage.setItem(key, JSON.stringify(positions)); } catch (error) {}
    lastURL = location.href;
  }
  function stop() {
    clearTimeout(timer);
    restoring = false;
  }
  function restore() {
    stop();
    var target = positions[location.href];
    lastURL = location.href;
    if (!target || !Number.isFinite(target.y) || Date.now() - target.time > 86400000) return;
    restoring = true;
    deadline = Date.now() + 4000;
    function attempt() {
      if (!restoring) return;
      // Repeat briefly for lazy images and collection HTML arriving after popstate.
      var root = document.documentElement;
      var previous = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      window.scrollTo({ left: target.x || 0, top: target.y, behavior: 'instant' });
      root.style.scrollBehavior = previous;
      if (Date.now() < deadline) timer = setTimeout(attempt, 120);
      else stop();
    }
    attempt();
  }
  ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(function (event) {
    window.addEventListener(event, stop, { passive: true });
  });
  var queued = false;
  window.addEventListener('scroll', function () {
    if (restoring || queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; save(); });
  }, { passive: true });
  // Capture before product links navigate, including on mobile.
  document.addEventListener('click', function () { save(); }, true);
  window.addEventListener('pagehide', save);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') save();
  });
  window.addEventListener('pageshow', function (event) {
    var navigation = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (event.persisted || (navigation && navigation.type === 'back_forward')) restore();
  });
  window.addEventListener('popstate', function () {
    // Hash links retain their normal anchor behavior.
    var before = new URL(lastURL);
    var after = new URL(location.href);
    if (before.pathname === after.pathname && before.search === after.search && before.hash !== after.hash) {
      stop(); lastURL = location.href; return;
    }
    restore();
  });
}());
